import type { AuthState } from '../../types/redux';
import type { AuthAction } from './actions';
import {
  LOGIN,
  NAV_TOGGLE,
  SAVE_PREFERENCES_STATE,
  SAVE_QUERY_SESSION,
  SAVE_TABLE_PAGESIZE,
  SAVE_TABLE_PREF,
  SET_FEATURE_FLAGS,
  SET_MFA,
} from './types';

const initialState: AuthState = {
  data: {},
  isCollapsed: true,
  tablePref: {},
  tablePageSize: {},
  querySession: {},
  mfa: { show: false },
  preferencesApi: {
    isPrefLoaded: false,
    isPrefLoadFailed: false,
  },
  featureFlags: {},
};

interface SaveTablePrefAction {
  tableKey: string;
  data: Record<string, unknown>;
}

const saveTablePreferences = (
  state: AuthState,
  action: SaveTablePrefAction
): AuthState | undefined => {
  const { tableKey, data } = action;
  if (!tableKey) {
    return;
  }
  return {
    ...state,
    tablePref: tableKey === 'master' ? data : { ...state.tablePref, [tableKey]: data },
  };
};

const saveTablePageSizes = (
  state: AuthState,
  action: SaveTablePrefAction
): AuthState | undefined => {
  const { tableKey, data } = action;
  if (!tableKey) {
    return;
  }
  return {
    ...state,
    tablePageSize: tableKey === 'master' ? data : { ...state.tablePageSize, [tableKey]: data },
  };
};

export const auth = (state: AuthState = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        data: action.data,
        isCollapsed: true,
      };
    case NAV_TOGGLE:
      return {
        ...state,
        isCollapsed: action.val === '' ? !state.isCollapsed : (action.val as boolean),
      };
    case SET_MFA:
      return {
        ...state,
        mfa: action.val,
      };
    case SAVE_TABLE_PREF:
      return saveTablePreferences(state, action) || state;
    case SAVE_TABLE_PAGESIZE:
      return saveTablePageSizes(state, action) || state;
    case SAVE_QUERY_SESSION:
      return {
        ...state,
        querySession:
          Object?.keys(action?.data || {})?.length > 0
            ? { ...state.querySession, ...action.data }
            : {},
      };
    case SAVE_PREFERENCES_STATE:
      return {
        ...state,
        preferencesApi: {
          ...state.preferencesApi,
          [action.key]: action.value,
        },
      };
    case SET_FEATURE_FLAGS:
      return {
        ...state,
        featureFlags: action.featureFlags || {},
      };
    default:
      return state;
  }
};
